import { render, staticRenderFns } from "./PatHisenseDetail.vue?vue&type=template&id=6ffa3a38&scoped=true"
import script from "./PatHisenseDetail.vue?vue&type=script&lang=js"
export * from "./PatHisenseDetail.vue?vue&type=script&lang=js"
import style0 from "./PatHisenseDetail.vue?vue&type=style&index=0&id=6ffa3a38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffa3a38",
  null
  
)

export default component.exports